import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
//Components-
import MuiHeader from "../../components/MuiHeader";
import MuiLoader from "../../components/MuiLoader";
import ContentEditor from "../../components/ContentEditor";
import ContentPreview from "../../components/ContentPreview";
//MUI-
import {
  TextField,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Typography,
  MenuItem,
  Modal,
  FormLabel,
  Card,
  Pagination,
  CustomTableCell,
  TablePagination,
  Table,
  Alert,
  Paper,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
// mui Icon
import DeleteIcon from "@mui/icons-material/Delete";
//Thunks
import {
  getAllBlocksThunk,
  postNewBlockThunk,
  deleteBlockDataThunk,
  getAllDistrictsThunk,
} from "./Blocks.Thunk";
// Slice
import { nullState } from "./Blocks.Slice";
// swal
import Swal from "sweetalert2";
// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BlockPage = () => {
  const dispatch = useDispatch();

  // store data
  const allStatedata = useSelector((state) => state.BlockSlice.districts);
  const allBlocksData = useSelector((state) => state.BlockSlice.blocks);
  const loading = useSelector((state) => state.BlockSlice.loading);
  // ----------------------
  const [state, setState] = useState("");
  const [newState, setNewState] = useState("");
  const [district, setDistrict] = useState("");
  const [block, setBlock] = useState("");
  //For modal opening
  const [open, setOpen] = useState(false);
  //For pagination purpose
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //For the validation on creation of data
  const [stateError, setStateError] = useState(false);
  const [districtError, setDistrictError] = useState(false);
  const [blockError, setBlockError] = useState(false);

  // dropdown onchange
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  //To change the state in the filter-
  const setChangingStates = (event) => {
    setState(event.target.value);
    if (event.target.value) {
      dispatch(getAllBlocksThunk(event.target.value));
    } else {
      dispatch(nullState());
    }
  };

  // ---------------------------------

  //For deleting a data-->
  const deleteDataOnButtonClick = (body) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#B4161B",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteBlockDataThunk(body._id)).then((response) => {
          //console.log("response delete--->", response);
          if (response.payload == "success") {
            dispatch(getAllBlocksThunk(body.statecode));
            toast.success("Successfully deleted !!");
          }
        });
      }
    });
  };
  // ------------------------------------

  //For opening and closing of the modal.
  const handleOpen = () => {
    setOpen(true);
    // disable_content_button = false;
  };
  const handleClose = () => {
    setOpen(false);
    setNewState("");
    setDistrict("");
    setBlock("");
  };
  // -------------------------------------

  useEffect(() => {
    dispatch(getAllDistrictsThunk());
  }, []);

  // Load state, district &block
  const createStates = (event) => {
    setNewState(event.target.value);
  };
  const createDistrict = (event) => {
    setDistrict(event.target.value);
  };

  const createBlock = (event) => {
    setBlock(event.target.value.trim());
  };
  // ----------------------------------

  //To get hold of all the districts based on the state code.
  let districtData = [];
  allStatedata.forEach((item) => {
    if (item.code == newState) {
      districtData = item.districts;
    }
  });

  //Create modal validation
  const handleCreateNewData = () => {
    const body = {
      statecode: newState,
      statevalue: newState,
      districtvalue: district,
      block: block,
    };

    const alreadyExistingBlock = allBlocksData.filter(
      (item) => item.block === body.block
    );

    if (
      body.statevalue === "" &&
      body.districtvalue === "" &&
      body.block === ""
    ) {
      setOpen(true);
      toast.error("Please select all the fields");
    } else if (body.statevalue === "") {
      setStateError(true);
      setOpen(true);
      toast.error("Please select a state");
    } else if (body.districtvalue === "") {
      setStateError(true);
      setOpen(true);
      toast.error("Please select a district");
    } else if (body.block === "" || body.block.length < 3) {
      setBlockError(true);
      setOpen(true);
      toast.error("Please enter a valid block");
    } else if (alreadyExistingBlock.length > 0) {
      toast.error("This data already exists !!");
    } else {
      dispatch(postNewBlockThunk(body)).then((response) => {
        if (response.payload == "success") {
          dispatch(getAllBlocksThunk(body.statecode));
        }
      });
      setOpen(false);
      setState(body.statecode);
      setNewState("");
      setDistrict("");
      setBlock("");
      toast.success("Successfully created data");
    }
  };
  // --------------------------------------------------

  return (
    <div>
      {/* mui header  */}
      <MuiHeader header="Blocks and Districts" />
      {/* state dropdown */}
      <FormControl
        sx={{ m: 1, minWidth: 180 }}
        style={{ marginTop: 73, paddingBottom: 40 }}
        size="small"
      >
        <InputLabel id="demo-select-small">Select State</InputLabel>
        <Select
          labelId="demo-select-small"
          id="demo-select-small"
          value={state}
          label="Select State"
          onChange={setChangingStates}
        >
          <MenuItem>None</MenuItem>
          {allStatedata.map((option) => (
            <MenuItem value={option.code}>{option.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      {state !== "" && state !== undefined ? (
        <Box>
          <Button variant="contained" onClick={handleOpen}>
            Create New
          </Button>
          {/* open modal  */}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              {/* heading  */}
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ display: "flex", justifyContent: "center" }}
              >
                Create New Data
              </Typography>
              {/* create state  */}
              <FormControl
                sx={{ m: 1, minWidth: 400 }}
                style={{ marginTop: 13 }}
                size="small"
              >
                <InputLabel id="demo-select-small">Select State</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  label="Select State"
                  value={newState}
                  onChange={createStates}
                >
                  <MenuItem value="">None</MenuItem>
                  {allStatedata.map((option) => (
                    <MenuItem key={option.id} value={option.code}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* create district  */}
              <FormControl sx={{ m: 1 }} size="small" style={{ minWidth: 400 }}>
                <InputLabel>Select District</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  label="Select District"
                  value={district}
                  onChange={createDistrict}
                >
                  <MenuItem value="">None</MenuItem>
                  {districtData.map((option) => (
                    <MenuItem key={option.id} value={option.name}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>{" "}
              <br />
              {/* create block  */}
              <FormControl sx={{ m: 1 }} size="small" style={{ minWidth: 400 }}>
                {/* <FormLabel>Enter Block</FormLabel> */}
                <TextField
                  placeholder="Enter Block"
                  onChange={createBlock}
                  type="text"
                >
                  {" "}
                </TextField>
              </FormControl>
              {/* close & save button  */}
              <div style={{ display: "flex", justifyContent: "space-around" }}>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  style={{ marginTop: 10 }}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  onClick={handleCreateNewData}
                  style={{ marginTop: 10 }}
                >
                  Save
                </Button>
              </div>
            </Box>
          </Modal>
        </Box>
      ) : null}
      <br />
      {/* table  */}
      <div>
        {/* {allBlocksData.length > 0 ? (
          <>
            <table>
              {" "}
              <thead>
                <tr>
                  <td style={{ width: "70px" }}>
                    <b>Sl no</b>
                  </td>
                  <td style={{ width: "250px" }}>
                    <b>District</b>
                  </td>
                  <td style={{ width: "130px" }}>
                    <b>Block</b>
                  </td>
                  <td>
                    <b>Action</b>
                  </td>
                </tr>
              </thead>
              {allBlocksData
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => {
                  return (
                    <tbody>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item.districtvalue}</td>
                        <td>{item.block}</td>
                        <td>
                          <Button
                             variant="contained"
                            size="small"
                            onClick={() => deleteDataOnButtonClick(item)}
                          >
                            <DeleteIcon style={{ color: "#E21717" }} />
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  );
                })}
            </table>{" "}
    
            <div style={{ float: "left" }}>
              <TablePagination
                rowsPerPageOptions={[5, 10, allBlocksData.length]}
                component="div"
                count={allBlocksData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </>
        ) : null} */}
        {allBlocksData.length > 0 ? (
          <>
            <Paper style={{ width: 500 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: "70px" }}>Sl no.</TableCell>
                    <TableCell style={{ width: "250px" }}>District</TableCell>
                    <TableCell style={{ width: "170px" }}>Block</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                {allBlocksData
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <TableBody key={index}>
                      <TableRow>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{item.districtvalue}</TableCell>
                        <TableCell>{item.block}</TableCell>
                        <TableCell>
                          <Button
                            size="small"
                            onClick={() => deleteDataOnButtonClick(item)}
                          >
                            <DeleteIcon style={{ color: "#E21717" }} />
                          </Button>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ))}
              </Table>
            </Paper>
            <div style={{ float: "left" }}>
              <TablePagination
                rowsPerPageOptions={[5, 10, allBlocksData.length]}
                component="div"
                count={allBlocksData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage} //
              />
            </div>
          </>
        ) : null}
      </div>
      {/* Toaster */}
      <ToastContainer />
      <MuiLoader open={loading} />
    </div> //
  );
};

export default BlockPage;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 10,
  p: 4,
};
